import { CircularProgress, Box, Typography } from "@mui/material";
import "../styles/LoadingSpinner.css";

export default function ({ message }) {
  return (
    <Box className="loading-spinner">
      <Box>
        <CircularProgress />
      </Box>
      {message && (
        <Box>
          <Typography variant="subtitle1">{message}</Typography>
        </Box>
      )}
    </Box>
  );
}
